import type { DocumentType, DocumentExtension } from "@/shared/types/documentTypes";

const LEGACY_TYPE_MAP: Record<string, string> = {
  insurance_documents: "insurance_document",
  tax_documents: "tax_document",
  bank_statements: "bank_statement",
  property_deeds: "property_deed",
  vehicle_titles: "vehicle_title",
  bank_investment_statement: "bank_statement",
  investment_statements: "investment_account_statement",
  tax_returns: "tax_document",
  my_photo_id: "identification_card",
  pension_documents: "other",
  social_security_documents: "other",
  medical_records: "other",
  marriage_certificate: "other",
  birth_certificate: "other",
  divorce_decree: "other",
  military_records: "discharge_papers",
  business_documents: "other",
  confirmation_document: "other",
  "Death Certificate": "death_certificate",
  Will: "will",
  Trust: "trust",
  "Insurance Documents": "insurance_document",
  "Tax Documents": "tax_document",
  "Bank / Investment Account Statement": "bank_statement",
  "Investment Account Statement": "investment_account_statement",
  "Property Deed": "property_deed",
  "Vehicle Title": "vehicle_title",
  "Credit Report": "credit_report",
  Other: "other",
};

const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  death_certificate: "Death Certificate",
  will: "Will",
  trust: "Trust",
  identification_card: "Identification Card",
  decedent_id: "Decedent's Identification Card",
  insurance_document: "Insurance Document",
  tax_document: "Tax Document",
  bank_statement: "Bank Statement",
  investment_account_statement: "Investment Account Statement",
  property_deed: "Property Deed",
  vehicle_title: "Vehicle Title",
  credit_report: "Credit Report",
  mortgage_statement: "Mortgage Statement",
  home_insurance_policy: "Home Insurance Policy",
  auto_loan_statement: "Auto Loan Statement",
  annuity_contract: "Annuity Contract",
  utility_bill: "Utility Bill",
  generated_letter: "Generated Letter",
  discharge_papers: "Discharge Papers (DD-214)",
  funeral_invoice: "Funeral Invoice",
  letters_testamentary: "Letters Testamentary",
  letters_administration: "Letters of Administration",
  certification_of_trust: "Certification of Trust",
  trust_amendment: "Trust Amendment",
  notice_to_beneficiaries: "Notice to Beneficiaries",
  ein_confirmation: "EIN Confirmation",
  payment_receipt: "Payment Receipt",
  other: "Other",
  insurance_documents: "Insurance Document",
  tax_documents: "Tax Document",
  bank_investment_statement: "Bank Statement",
  financial_property_documents: "Financial / Property Documents",
};

export function normalizeDocumentType(documentType: string | null | undefined): string {
  if (!documentType) return "other";
  const normalized = documentType.toLowerCase().trim();
  return LEGACY_TYPE_MAP[documentType] || LEGACY_TYPE_MAP[normalized] || documentType;
}

export function getDocumentTypeLabel(documentType: DocumentType | string): string {
  if (!documentType) return "Unknown";

  const normalized = normalizeDocumentType(documentType);

  if (DOCUMENT_TYPE_LABELS[normalized]) {
    return DOCUMENT_TYPE_LABELS[normalized];
  }

  if (DOCUMENT_TYPE_LABELS[documentType]) {
    return DOCUMENT_TYPE_LABELS[documentType];
  }

  return documentType.replace(/_/g, " ").replace(/(^|\s)\w/g, (l) => l.toUpperCase());
}

export function coalesceDocumentExtension(mimeType: string): DocumentExtension {
  if (mimeType === "application/pdf") return "application/pdf";
  if (mimeType === "image/jpeg") return "image/jpeg";
  if (mimeType === "image/png") return "image/png";
  return "other";
}
